import { render, staticRenderFns } from "./CardTextButton.vue?vue&type=template&id=21ec61c3&"
import script from "./CardTextButton.vue?vue&type=script&lang=js&"
export * from "./CardTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports